import { useFormik } from "formik";
import React, { useState, useEffect, useContext } from "react";
import DoLaundry from "../Components/Laundry/DoLaundry";
import LaundryCart from "../Components/Laundry/LandryCart";
import { ButtonContainer } from "../Components/Shared/ButtonComponent";
import LaundrySummary from "../Components/Laundry/LaundrySummary";
import useLaundry from "../hooks/useLaundry";
import ServiceType from "../Components/Form/ServiceType";
import Checkout from "../Components/Laundry/Checkout";
import Modal from "../Components/Modal/Modal";
import { LoaderContext } from "../context/LoaderContext";
import TailoringContext from "../context/TailoringContext";
import { ImSpinner2 } from "react-icons/im";

const LaundryDetails = ({ setLaundryDetails }) => {
  const { handleGetLaundryTypes, handleMakeLaundryOrder } = useLaundry();
  const { errMsg } = useContext(LoaderContext);
  const { loader } = useContext(TailoringContext);

  const [services, setServices] = useState(null);
  const [laundryObj, setLaundryObj] = useState([]);
  const [clothCount, setClothCount] = useState(1);
  const [foldOrHang, setFoldOrHang] = useState(null);
  const [checkoutModal, setcheckoutModal] = useState(false);
  const [laundryNewOrder, setLaundryNewOrder] = useState([]);
  const [laundryTypData, setLaundryTypData] = useState();
  const [uploadlaundryImage, setUploadlaundryImage] = useState(false);
  const [laundrySummary, setLaundrySummary] = useState(false);

  const user = JSON.parse(localStorage.getItem("_2mseamlessTailoring"));
  console.log(user?.user);

  useEffect(() => {
    handleGetLaundryTypes().then((res) => setServices(res?.data));
    // eslint-disable-next-line
  }, []);

  const formik = useFormik({
    initialValues: {
      delivery: "",
      delivery_address: "",
      pick_up: "",
      pick_up_address: "",
      factory_location: "",
      service_type: "",
      to_state: "",
      lga: "",
      whatsapp_number: "",
      cloth_type: "",
      first_name: user?.user.first_name,
      last_name: user?.user.last_name,
      laundry_type: {},
    },
    onSubmit(values) {
      const value = { ...values, laundry_type: laundryObj };
      console.log(value);
      handleMakeLaundryOrder(value).then((res) => {
        setLaundryNewOrder(res?.data);
        window.localStorage.setItem(
          "orderId",
          res?.data?.laundry_id?.InsertedID
        );
        setLaundryTypData(laundryObj);
        setLaundrySummary(true);
        console.log(value);
      });
    },
  });

  const handleAddCoth = () => {
    let obj = {
      cloth_count: clothCount,
      cloth_type: formik.values.cloth_type,
      service_type: formik.values.service_type,
      extra: foldOrHang,
    };
    setLaundryObj((prev) => [...prev, obj]);
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="col-12">
        <div className="col-12 side-menu">
          <div className="side-menu__overlay" />
          <div className="side-menu__content laundry_details">
            <div className="laundry_header">
              <span onClick={() => setLaundryDetails(false)}>
                <i className="fa-solid fa-xmark"></i>
              </span>
              <div>
                <p>Do Laundry</p>
                {errMsg ? (
                  <p className="text-danger">{errMsg}</p>
                ) : (
                  <p>Please fill this form with the correct details</p>
                )}
              </div>
            </div>
            <div className="laundry-content">
              <div>
                <p>Please select the type of service you want</p>
                <select
                  name="service_type"
                  onChange={formik.handleChange}
                  className="form-select style_form form-select-lg mb-3 shadow-none"
                  aria-label=".form-select-lg example"
                >
                  <option value="">select Service Type</option>
                  {services?.["laundry-type"]?.map((item) => (
                    <option value={item.name}>{item.name}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <ServiceType {...{ foldOrHang, setFoldOrHang }} />
              </div>
              <div>
                <LaundryCart
                  {...{
                    clothCount,
                    setClothCount,
                    laundryObj,
                    setLaundryObj,
                    services,
                    handleAddCoth,
                    onChange: formik.handleChange,
                  }}
                />
              </div>

              <DoLaundry {...{ onChange: formik.handleChange, formik }} />
              <div className="laundry_contact">
                <p>Enter WhatsApp Contact</p>
                <textarea
                  name="whatsapp_number"
                  onChange={formik.handleChange}
                  placeholder="Enter Number here"
                  className="laundry_textarea"
                ></textarea>
              </div>
            </div>
            <div className="laundry-footer">
              <div>
                <ButtonContainer>
                  {" "}
                  {loader ? <ImSpinner2 className="spin" /> : "Next"}
                </ButtonContainer>
              </div>
              <div>
                <ButtonContainer onClick={() => setLaundryDetails(false)} cart>
                  Cancel
                </ButtonContainer>
              </div>
            </div>
          </div>
        </div>
        {/* <div
          className={
            laundrySummary
              ? "laundrySummary-menu-expanded"
              : "laundrySummary-menu"
          }
        >
          <div>
            <LaundrySummary
              {...{
                setLaundrySummary,
                setLaundryDetails,
                laundryNewOrder,
                uploadlaundryImage,
                setUploadlaundryImage,
              }}
            />
          </div>
        </div> */}
      </form>
      {laundrySummary && (
        <Modal>
          <LaundrySummary
            {...{
              setLaundrySummary,
              setLaundryDetails,
              laundryNewOrder,
              uploadlaundryImage,
              setUploadlaundryImage,
            }}
          />
        </Modal>
      )}
      {checkoutModal && (
        <Checkout
          setcheckoutModal={setcheckoutModal}
          laundryNewOrder={laundryNewOrder}
          laundryTypData={laundryTypData}
          uploadlaundryImage={uploadlaundryImage}
          setUploadlaundryImage={setUploadlaundryImage}
        />
      )}
    </>
  );
};

export default LaundryDetails;
